import { render, staticRenderFns } from "./materialDetail.vue?vue&type=template&id=133a35f8&scoped=true&"
import script from "./materialDetail.vue?vue&type=script&lang=js&"
export * from "./materialDetail.vue?vue&type=script&lang=js&"
import style0 from "./materialDetail.vue?vue&type=style&index=0&id=133a35f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a35f8",
  null
  
)

export default component.exports